import { ApplicationField } from './application-field';

export class CompletedApplication {
    id: string;
    contactId: string;
    applicationId: string;
    unitId?: string;
    responses: [] = [];
    createdAt: string;
    needsApplicationFee: boolean;

    constructor(body: any) {
        this.id = body.id;
        this.contactId = body.contactId;
        this.applicationId = body.applicationId;
        this.unitId = body.unitId;
        this.createdAt = body.createdAt;
        this.needsApplicationFee = body.needsApplicationFee;
        if (body.responses && body.responses.length) {
            this.responses = body.responses.map(
                (r: any) => new ApplicationResponseItem(r),
            );
        }
    }
}

export class ApplicationResponseItem {
    id: string;
    contactId: string;
    clientApplicationFieldId: string;
    responseSet: number;
    response: string;

    constructor(body: any) {
        this.id = body.id;
        this.contactId = body.contactId;
        this.clientApplicationFieldId = body.clientApplicationFieldId;
        this.response = body.response;
        this.responseSet = body.responseSet || 1;
    }
}

export interface ApplicationResponseDisplay {
    section: string;
    question: ApplicationField;
    response: string;
    responseSet: number;
}
